import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProfileInitialStateInterface } from "../../types/reduxSlices";
import { IFacility } from "../../types/api";

const initialState: ProfileInitialStateInterface = {
  ProfileUserInfo: {
    FullName: "",
    FullNameEn: "",
    FullNameAr: "",
    phoneNumber: "",
    UserName: "",
    Facilities: [],
    CountryId: "",
    Country: null,
    token: "",
    Id: 0,
    Image: "",
    Reason: "",
    IsVerified: null,
    IsOwner: false,
    IsProfileLoaded: false,
    StaffResourceId: 0,
    Resource: {
      Id: 0,
      Url: null,
      Type: "",
      ItemId: 0,
      ApplicationId: 0,
      IsPublic: false,
      Extenstion: "",
    },
  },
  ProfileCurrentFacility: {
    Id: 0,
    Name: "",
    NameEn: "",
    NameAr: "",
    FacilityTypeId: 0,
    CountryId: 0,
    CompletedPercentage: 0,
    Address: "",
    Longitude: 0,
    Latitude: 0,
    AreaId: 0,
    Verified: null,
    IsOpen: null,
    AccountId: 0,
    ResourceId: 0,
    Image: "",
    HasInsurance: false,
    BasicInfoPercentage: null,
    AddressPercentage: 0,
    ContactInfoPercentage: null,
    WorkingTimePercentage: null,
    InsurancePercentage: null,
    IsDefaultImage: false,
    FacilityType: {
      Id: 0,
      Name: "",
      Image: "",
      DescriptionEn: null,
      DescriptionAr: null,
      Description: "",
      SelectedImage: "",
      Code: "",
    },
    Country: {
      Id: 0,
      NameEn: "",
      NameAr: "",
      Name: "",
      Flag: "",
      ZipCode: "",
      Iso: "",
    },
    Resource: {
      Id: 0,
      Url: null,
      Type: "",
      ItemId: 0,
      ApplicationId: 0,
      IsPublic: false,
      Extenstion: "",
    },
    City: {
      Id: 0,
      NameEn: "",
      NameAr: "",
      Name: "",
      CountryId: 0,
    },
    Area: {
      Id: 0,
      NameEn: "",
      NameAr: "",
      Name: "",
      CityId: 0,
    },
  },
  ProfileFacilities: [],
  ProfileOwnerFacilities: [],
  ProfileContactTypes: [
    {
      Id: 0,
      NameAr: "",
      NameEn: "",
      Name: "",
      Code: "",
      Count: 0,
      HasCountry: false,
    },
  ],
  showReasonPopup: false,
  showStaffLicensePopup:false
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    updatePersonalProfileInfo: (
      state,
      action: PayloadAction<
        Partial<ProfileInitialStateInterface["ProfileUserInfo"]>
      >,
    ) => {
      const {
        FullName,
        FullNameEn,
        FullNameAr,
        phoneNumber,
        token,
        Id,
        Image,
        Reason,
        IsVerified,
        IsProfileLoaded,
        CountryId,
        Country,
        IsOwner,
        Facilities,
        StaffResourceId,
        Resource
      } = action.payload;
      if (IsProfileLoaded !== undefined)
        state.ProfileUserInfo.IsProfileLoaded = IsProfileLoaded;
      if (Reason !== undefined) state.ProfileUserInfo.Reason = Reason;
      if (CountryId !== undefined) state.ProfileUserInfo.CountryId = CountryId;
      if (IsVerified !== undefined)
        state.ProfileUserInfo.IsVerified = IsVerified;
      if (Id !== undefined) state.ProfileUserInfo.Id = Id;
      if (Image !== undefined) state.ProfileUserInfo.Image = Image;
      if (Country !== undefined) state.ProfileUserInfo.Country = Country;
      if (token !== undefined) state.ProfileUserInfo.token = token;
      if (FullName !== undefined) state.ProfileUserInfo.FullName = FullName;
      if (FullNameEn !== undefined)
        state.ProfileUserInfo.FullNameEn = FullNameEn;
      if (FullNameAr !== undefined)
        state.ProfileUserInfo.FullNameAr = FullNameAr;
      if (phoneNumber !== undefined)
        state.ProfileUserInfo.phoneNumber = phoneNumber;
      if (Facilities !== undefined)
        state.ProfileUserInfo.Facilities = Facilities;
      if (IsOwner !== undefined) state.ProfileUserInfo.IsOwner = IsOwner;
      if (StaffResourceId !== undefined) state.ProfileUserInfo.StaffResourceId = StaffResourceId;
      if (Resource !== undefined) state.ProfileUserInfo.Resource = Resource;
    },

    updateProfileCurrentFacilityInfo: (
      state,
      action: PayloadAction<
        Partial<ProfileInitialStateInterface["ProfileCurrentFacility"]>
      >,
    ) => {
      state.ProfileCurrentFacility = {
        ...state.ProfileCurrentFacility,
        ...action.payload,
      };
    },
    updateProfileFacilities: (state, action: PayloadAction<IFacility[]>) => {
      state.ProfileFacilities = action.payload;
    },
    updateProfileOwnerFacilities: (
      state,
      action: PayloadAction<IFacility[]>,
    ) => {
      state.ProfileOwnerFacilities = action.payload;
    },
    updateProfileContact: (
      state,
      action: PayloadAction<
        ProfileInitialStateInterface["ProfileContactTypes"]
      >,
    ) => {
      state.ProfileContactTypes = action.payload;
    },
    setShowReasonPopup: (state, action: PayloadAction<boolean>) => {
      state.showReasonPopup = action.payload;
    },
    setStaffLicensePopup: (state, action: PayloadAction<boolean>) => {
      state.showStaffLicensePopup = action.payload;
    },
  },
});

export const {
  updatePersonalProfileInfo,
  updateProfileCurrentFacilityInfo,
  updateProfileContact,
  updateProfileFacilities,
  updateProfileOwnerFacilities,
  setShowReasonPopup,
  setStaffLicensePopup
} = profileSlice.actions;

export default profileSlice.reducer;
